import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { StatusPerencanaan } from 'types/kinerja-ps-pegawai'

const getBadgeProps = (
  state: StatusPerencanaan,
  separateRevisionStates = false
): { text: string; variant: BadgeProps['variant'] } => {
  switch (state) {
    case 'MULAI_PERENCANAAN':
      return { text: 'Mulai Perencanaan', variant: 'neutral' }
    case 'SIAP_DIAJUKAN':
      return { text: 'Siap diajukan', variant: 'informational' }
    case 'SEDANG_DIPERIKSA':
    case 'DIKIRIM_TK':
    case 'SUDAH_DIREVISI':
      return { text: 'Sedang diperiksa', variant: 'warning' }
    case 'DIARAHKAN_REVISI_TK':
      if (separateRevisionStates) {
        return {
          text: 'Diarahkan revisi oleh Tim Kinerja',
          variant: 'warning',
        }
      }
      return {
        text: 'Lakukan revisi sesuai arahan',
        variant: 'critical',
      }
    case 'DIARAHKAN_REVISI_PPK':
      if (separateRevisionStates) {
        return {
          text: 'Diarahkan revisi oleh Pejabat Penilai Kinerja',
          variant: 'warning',
        }
      }
      return {
        text: 'Lakukan revisi sesuai arahan',
        variant: 'critical',
      }
    case 'DISETUJUI_PPK':
    case 'PELAKSANAAN_DIMULAI':
      return { text: 'Disetujui Pejabat Penilai Kinerja', variant: 'success' }
  }
}

export function PlanningStatusBadge({
  state,
  separateRevisionStates = false,
}: {
  state: StatusPerencanaan
  separateRevisionStates?: boolean
}) {
  const badgeProps = getBadgeProps(state, separateRevisionStates)

  if (!badgeProps) {
    // This statement should be unreachable.
    // If it's reached, it means there's a new state that's not handled.

    console.error(`Invalid perencanaan state: ${state}`)

    return null
  }

  return (
    <Badge variant={badgeProps.variant} className="w-fit">
      {badgeProps.text}
    </Badge>
  )
}

export default PlanningStatusBadge
